import { useState, useEffect, useCallback } from 'react';
import { 
  createAvoir, validateAvoir1, validateAvoir3, getAvoirById, updateAvoir, deleteAvoir,
  getAllAvoir,  addItemToAvoir,
  deleteItemFromAvoir, updateItemInAvoir, getItemsInAvoir,saveAvoir,unvalidateAvoir,
  getAvoirItemsPriceHistory,
  // Demarque
  listDemarques as apiListDemarques,
  createDemarque as apiCreateDemarque,
  getDemarque as apiGetDemarque,
  updateDemarque as apiUpdateDemarque,
  deleteDemarque as apiDeleteDemarque,
  validateDemarque as apiValidateDemarque,
  unvalidateDemarque as apiUnvalidateDemarque,
  // CorrectionStock
  listCorrectionStocks as apiListCorrectionStocks,
  createCorrectionStock as apiCreateCorrectionStock,
  getCorrectionStock as apiGetCorrectionStock,
  updateCorrectionStock as apiUpdateCorrectionStock,
  deleteCorrectionStock as apiDeleteCorrectionStock,
  validateCorrectionStock as apiValidateCorrectionStock,
  unvalidateCorrectionStock as apiUnvalidateCorrectionStock,
  // Seed DBF upload
  uploadAvoirsDBF,
  uploadAvoirsDetailsDBF,
  uploadBothAvoirsDBF,
  // Demarque Seed DBF upload
  uploadDemarqueDBF,
  uploadDemarqueDetailsDBF,
  uploadBothDemarqueDBF
} from '../models/avoirAPI'; // Adjust the import path as necessary

export const useCreateAvoir = () => {
  const [error, setError] = useState('');
  const [isCreated, setIsCreated] = useState(false);

  const handleCreate = async (avoirData) => {
    try {
      const avoir = await createAvoir(avoirData);
      setIsCreated(true);
      return avoir.data;
    } catch (err) {
      setError(err.message);
      setIsCreated(false);
    }
  };

  return { handleCreate, error, isCreated };
};

export const useSaveAvoir = () => {
  const [error, setError] = useState('');
  const [isSaved, setIsSaved] = useState(false);

  const handleSaveAvoir = async (data) => {
    try {
      if (!data.avoir) {
        throw new Error('Invalid data structure. Avoir is required.');
      }

      // Items are optional - if undefined, backend will skip item updates
      await saveAvoir(data);
      setIsSaved(true);
      setError('');
    } catch (err) {
      setError(err.message);
      setIsSaved(false);
      throw err;
    }
  };

  return { handleSaveAvoir, error, isSaved };
};


export const useValidateAvoir1 = () => {
  const [error, setError] = useState('');
  const [isValidated, setIsValidated] = useState(false);

  const validate1 = async (refAvoir) => {
    try {
      await validateAvoir1(refAvoir);
      setIsValidated(true);
    } catch (err) {
      setError(err.message);
      setIsValidated(false);
      throw err;
    }
  };

  return { validate1, error, isValidated };
};

export const useValidateAvoir3 = () => {
  const [error, setError] = useState('');
  const [isValidated, setIsValidated] = useState(false);

  const validate3 = async (refAvoir) => {
    try {
      await validateAvoir3(refAvoir);
      setIsValidated(true);
    } catch (err) {
      setError(err.message);
      setIsValidated(false);
      throw err;
    }
  };

  return { validate3, error, isValidated };
};




export const useFetchAvoirById = (id) => {
  const [avoir, setAvoir] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Define the fetching logic as a callable function using useCallback
  const fetchAvoir = useCallback(() => {
    if (id) {
      setLoading(true);
      setError(''); // Reset error state before new fetch attempt
      getAvoirById(id)
        .then(response => {
          setAvoir(response.data);
          setLoading(false);
        })
        .catch(err => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [id]);

  // Invoke fetchAvoir when the component mounts and when id changes
  useEffect(() => {
    fetchAvoir();
  }, [fetchAvoir]);

  // Return all the state management vars and the refetch function
  return { avoir, loading, error, refetch: fetchAvoir };
};


export const useUpdateAvoir = () => {
  const [error, setError] = useState('');
  const [isUpdated, setIsUpdated] = useState(false);

  const handleUpdate = async (id, avoirData) => {
    try {
      await updateAvoir(id, avoirData);
      setIsUpdated(true);
    } catch (err) {
      setError(err.message);
      setIsUpdated(false);
    }
  };

  return { handleUpdate, error, isUpdated };
};

export const useDeleteAvoir = () => {
  const [error, setError] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);

  const handleDelete = async (id) => {
    try {
      await deleteAvoir(id);
      setIsDeleted(true);
    } catch (err) {
      setError(err.message);
      setIsDeleted(false);
    }
  };

  return { handleDelete, error, isDeleted };
};



export const useFetchAllAvoir = () => {
  const [avoir, setAvoir] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Define the fetching logic as a callable function using useCallback
  const fetchAllAvoir = useCallback(() => {
    setLoading(true);
    setError(''); // Reset error state before new fetch attempt
    getAllAvoir()
      .then(response => {
        setAvoir(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []); // Empty dependency array since this doesn't depend on any props or state

  // Initial fetch when the component mounts
  useEffect(() => {
    fetchAllAvoir();
  }, [fetchAllAvoir]);

  // Return all the state management vars and the refetch function
  return { avoir, loading, error, refetch: fetchAllAvoir };
};



  export const useAddItemToAvoir = () => {
    const [error, setError] = useState('');
    const [isAdded, setIsAdded] = useState(false);
  
    const addItem = async (refAvoir, itemData) => {
      try {
        await addItemToAvoir(refAvoir, itemData);
        setIsAdded(true);
      } catch (err) {
        setError(err.message);
        setIsAdded(false);
      }
    };
  
    return { addItem, error, isAdded };
  };

  
  export const useDeleteItemFromAvoir = () => {
    const [error, setError] = useState('');
    const [isDeleted, setIsDeleted] = useState(false);
  
    const deleteItem = async (refAvoir, codeArt) => {
      try {
        await deleteItemFromAvoir(refAvoir, codeArt);
        setIsDeleted(true);
      } catch (err) {
        setError(err.message);
        setIsDeleted(false);
      }
    };
  
    return { deleteItem, error, isDeleted };
  };

  
  export const useUpdateItemInAvoir = () => {
    const [error, setError] = useState('');
    const [isUpdated, setIsUpdated] = useState(false);
  
    const updateItem = async (refAvoir, codeArt, itemData) => {
      try {
        await updateItemInAvoir(refAvoir, codeArt, itemData);
        setIsUpdated(true);
      } catch (err) {
        setError(err.message);
        setIsUpdated(false);
      }
    };
  
    return { updateItem, error, isUpdated };
  };

  
  export const useFetchItemsInAvoir = (refAvoir, fetchTrigger) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
  
    const fetchItems = useCallback(() => {
      if (refAvoir) {
        setLoading(true);
        getItemsInAvoir(refAvoir)
          .then(response => {
            setItems(response.data);
            setLoading(false);
          })
          .catch(err => {
            setError(err.message);
            setLoading(false);
          });
      }
    }, [refAvoir]);
  
    useEffect(() => {
      fetchItems();
    }, [fetchItems, fetchTrigger]);
  
    const updateItemsLocally = useCallback((updatedItem) => {
      setItems(prevItems => 
        prevItems.map(item => 
          item.CODE_ART === updatedItem.CODE_ART ? { ...item, ...updatedItem } : item
        )
      );
    }, []);
  
    return { 
      items, 
      loading, 
      error, 
      refetch: fetchItems,
      updateItemsLocally
    };
  };

// Fetch last N years price history for items for a given client compte
export const useFetchAvoirItemsPriceHistory = (compte, codeArts, years = 3) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = useCallback(() => {
    if (!compte || !Array.isArray(codeArts) || codeArts.length === 0) return;
    setLoading(true);
    setError('');
    getAvoirItemsPriceHistory(compte, codeArts, years)
      .then(res => { setData(res.data || []); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [compte, codeArts, years]);

  useEffect(() => { fetchData(); }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};


// Modified useUnvalidateAvoir hook
export const useUnvalidateAvoir = () => {
  const [error, setError] = useState('');
  const [isUnvalidated, setIsUnvalidated] = useState(false);

  const unvalidate = async (refAvoir) => {
    try {
      const response = await unvalidateAvoir(refAvoir);
      setIsUnvalidated(true);
      setError('');
      return response.data; // Return the response data which may contain detailed message
    } catch (err) {
      // Extract the most meaningful error message
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      setIsUnvalidated(false);
      throw new Error(errorMessage);
    }
  };

  return { unvalidate, error, isUnvalidated };
};

// Demarque hooks
export const useListDemarques = (query = {}) => {
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = useCallback(() => {
    setLoading(true);
    apiListDemarques(query)
      .then(res => { setData(res.data); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [JSON.stringify(query)]);

  useEffect(() => { fetchData(); }, [fetchData]);

  return { ...data, loading, error, refetch: fetchData };
};

export const useCreateDemarque = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleCreate = async (payload) => {
    setLoading(true);
    try {
      const res = await apiCreateDemarque(payload);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { handleCreate, loading, error };
};

export const useUpdateDemarque = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleUpdate = async (ref, payload) => {
    setLoading(true);
    try {
      const res = await apiUpdateDemarque(ref, payload);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { handleUpdate, loading, error };
};

export const useDeleteDemarque = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleDelete = async (ref) => {
    setLoading(true);
    try {
      await apiDeleteDemarque(ref);
      setLoading(false);
      return true;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { handleDelete, loading, error };
};

export const useFetchDemarque = (ref) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchOne = useCallback(async () => {
    if (!ref) return;
    setLoading(true);
    setError('');
    try {
      const res = await apiGetDemarque(ref);
      setData(res.data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [ref]);

  useEffect(() => { fetchOne(); }, [fetchOne]);

  return { data, loading, error, refetch: fetchOne };
};

export const useValidateDemarque = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const validate = async (ref) => {
    setLoading(true);
    setError('');
    try {
      const res = await apiValidateDemarque(ref);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { validate, loading, error };
};

export const useUnvalidateDemarque = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const unvalidate = async (ref) => {
    setLoading(true);
    setError('');
    try {
      const res = await apiUnvalidateDemarque(ref);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { unvalidate, loading, error };
};

// CorrectionStock hooks
export const useListCorrectionStocks = (query = {}) => {
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = useCallback(() => {
    setLoading(true);
    apiListCorrectionStocks(query)
      .then(res => { setData(res.data); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [JSON.stringify(query)]);

  useEffect(() => { fetchData(); }, [fetchData]);

  return { ...data, loading, error, refetch: fetchData };
};

export const useCreateCorrectionStock = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleCreate = async (payload) => {
    setLoading(true);
    try {
      const res = await apiCreateCorrectionStock(payload);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { handleCreate, loading, error };
};

export const useUpdateCorrectionStock = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleUpdate = async (ref, payload) => {
    setLoading(true);
    try {
      const res = await apiUpdateCorrectionStock(ref, payload);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { handleUpdate, loading, error };
};

export const useDeleteCorrectionStock = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleDelete = async (ref) => {
    setLoading(true);
    try {
      await apiDeleteCorrectionStock(ref);
      setLoading(false);
      return true;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { handleDelete, loading, error };
};

export const useFetchCorrectionStock = (ref) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchOne = useCallback(async () => {
    if (!ref) return;
    setLoading(true);
    setError('');
    try {
      const res = await apiGetCorrectionStock(ref);
      setData(res.data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [ref]);

  useEffect(() => { fetchOne(); }, [fetchOne]);

  return { data, loading, error, refetch: fetchOne };
};

export const useValidateCorrectionStock = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const validate = async (ref) => {
    setLoading(true);
    setError('');
    try {
      const res = await apiValidateCorrectionStock(ref);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { validate, loading, error };
};

export const useUnvalidateCorrectionStock = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const unvalidate = async (ref) => {
    setLoading(true);
    setError('');
    try {
      const res = await apiUnvalidateCorrectionStock(ref);
      setLoading(false);
      return res.data;
    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
  };
  return { unvalidate, loading, error };
};

// Seed DBF upload hooks
export const useUploadAvoirsDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (file) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await uploadAvoirsDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

export const useUploadAvoirsDetailsDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (file) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await uploadAvoirsDetailsDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

export const useUploadBothAvoirsDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (avoirsFile, detailsFile) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('avoirsFile', avoirsFile);
    formData.append('detailsFile', detailsFile);

    try {
      const response = await uploadBothAvoirsDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

// Demarque Seed DBF upload hooks
export const useUploadDemarqueDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (file) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await uploadDemarqueDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

export const useUploadDemarqueDetailsDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (file) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await uploadDemarqueDetailsDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

export const useUploadBothDemarqueDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (demarqueFile, detailsFile) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('demarqueFile', demarqueFile);
    formData.append('detailsFile', detailsFile);

    try {
      const response = await uploadBothDemarqueDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

